<template>
  <b-modal
    id="nuova-delega-modal"
    ref="modal"
    title="Nuova Delega"
    @ok="handleOk"
    @hidden="resetForm"
  >
    <b-form>
      <!-- CF Titolare -->
      <b-form-group
        label="Codice Fiscale Titolare *"
        label-for="cf-input"
      >
        <b-form-input
          id="cf-input"
          v-model="form.codiceFiscaleTitolare"
          :state="fieldState('codiceFiscaleTitolare')"
          trim
          uppercase
        ></b-form-input>
        <b-form-invalid-feedback v-if="!$v.form.codiceFiscaleTitolare.required">
          Campo obbligatorio
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-else-if="!$v.form.codiceFiscaleTitolare.codiceFiscale">
          Codice fiscale non valido
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- Codice RU -->
      <b-form-group
        label="Codice RU *"
        label-for="ru-input" 
      >
        <b-form-input
          id="ru-input"
          v-model="form.codiceRu"
          :state="fieldState('codiceRu')"
          trim
        ></b-form-input>
        <b-form-invalid-feedback v-if="!$v.form.codiceRu.required">
          Campo obbligatorio
        </b-form-invalid-feedback>
      </b-form-group>


      <!-- Codice BU -->
      <b-form-group
        label="Codice BU *"
        label-for="bu-input"
      >
        <b-form-input
          id="bu-input" 
          v-model="form.codiceBu"
          :state="fieldState('codiceBu')"
          trim
        ></b-form-input>
        <b-form-invalid-feedback v-if="!$v.form.codiceBu.required">
          Campo obbligatorio
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- CF Dichiarante -->
      <b-form-group
        label="Codice Fiscale Dichiarante"
        label-for="cf-dichiarante-input"
      >
        <b-form-input
          id="cf-dichiarante-input"
          v-model="form.codiceFiscaleDichiarante"
          :state="fieldState('codiceFiscaleDichiarante')"
          trim
          uppercase
        ></b-form-input>
        <b-form-invalid-feedback v-if="!$v.form.codiceFiscaleDichiarante.codiceFiscale">
          Codice fiscale non valido
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="!$v.form.codiceFiscaleDichiarante.differentFromTitolare">
          Il CF del dichiarante deve essere diverso dal titolare
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- Nominativo Dichiarante -->
      <b-form-group
        label="Nominativo Dichiarante"
        label-for="nominativo-input"
        :state="fieldState('nominativoDichiarante')"
      >
        <b-form-input
          id="nominativo-input"
          v-model="form.nominativoDichiarante"
          :disabled="!form.codiceFiscaleDichiarante"
        ></b-form-input>
        <b-form-invalid-feedback v-if="!$v.form.nominativoDichiarante.requiredIf">
          Campo obbligatorio se presente CF dichiarante
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- Sede CAF -->
      <b-form-group
        label="Sede CAF *"
        label-for="sede-select"
      >
        <b-form-select
          id="sede-select"
          v-model="form.idSede"
          :options="sediCafOptions"
          :state="fieldState('idSede')"
          value-field="value"
          text-field="text"
        ></b-form-select>
        <b-form-invalid-feedback v-if="!$v.form.idSede.required">
          Campo obbligatorio
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import CodiceFiscale from '../utils/codice-fiscale'

// const codiceFiscale = (value) => {
//   var reCF = /[A-Za-z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9lmnpqrstuvLMNPQRSTUV]{2}[A-Za-z]{1}[0-9lmnpqrstuvLMNPQRSTUV]{3}[A-Za-z]{1}/
  
//   if (value && value.length === 16)
//     return reCF.test(value)

//   return false
// }

const codiceFiscale = (value) => {
  if (!value || value.length !== 16) {
    //console.log('CF non valido: lunghezza errata', value)
    return false
  }
  
  try {
    // 1. Verifica carattere di controllo
    const cfBase = value.slice(0, 15)
    const checkCode = CodiceFiscale.getCheckCode(cfBase)
    // console.log('Verifica carattere di controllo:', {
    //   cfBase,
    //   calcolato: checkCode,
    //   presente: value[15].toUpperCase()
    // })
    
    if (checkCode !== value[15].toUpperCase()) {
      // console.log('CF non valido: carattere di controllo errato')
      return false
    }

    // 2. Denormalizza il codice fiscale
    const denormalizedValue = CodiceFiscale.denormalizeOmocodie(value)
    // console.log('CF denormalizzato:', denormalizedValue)

    // 3. Verifica formato base
    const baseFormat = /^[A-Z]{6}[0-9]{2}[A-Z]{1}[0-9]{2}/i
    const isValidFormat = baseFormat.test(denormalizedValue)
    // console.log('Verifica formato base:', {
      // regex: baseFormat,
      // isValid: isValidFormat
    // })
    
    return isValidFormat

  } catch (err) {
    console.error('Errore durante la validazione del CF:', err)
    return false
  }
}

export default {
  name: 'NuovaDelegaModal',

  data() {
    return {
      form: {
        codiceFiscaleTitolare: '',
        codiceRu: '',
        codiceBu: '',
        anniDichiarazione: '2019,2021,2023', //'2020,2021,2022'
        codiceFiscaleDichiarante: '',
        nominativoDichiarante: '',
        idSede: null
      },
      sediCafOptions: []
    }
  },

  validations: {
    form: {
      codiceFiscaleTitolare: { required, codiceFiscale },
      codiceRu: { required },
      codiceBu: { required },
      codiceFiscaleDichiarante: { 
        codiceFiscale: value => !value || codiceFiscale(value),
        differentFromTitolare(val) {
          return !val || val !== this.form.codiceFiscaleTitolare
        }
      },
      nominativoDichiarante: { 
        requiredIf: requiredIf(function() {
          return !!this.form.codiceFiscaleDichiarante
        })
      },
      idSede: { required }
    }
  },

  async created() {
    await this.loadSediCaf()
  },

  methods: {
    async loadSediCaf() {
      try {
        const sedi = await this.$store.dispatch('caf/loadSedi')

        this.sediCafOptions = sedi.map(sede => {
          const option = {
            value: Number(sede.idSede), 
            text: sede.nomeSede
          }
          return option
        })
      } catch (err) {
        this.$ui.showError(err)
      }
    },

    fieldState(field) {
      const v = this.$v.form[field]
      return v.$dirty && v.$error ? false : null
    },

    async handleOk(bvModalEvent) {
      bvModalEvent.preventDefault()
      
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$ui.notify({
          type: 'warning', 
          message: 'Compilare correttamente tutti i campi'
        })
        return
      }

      try {
        // Verifica titolare
        const titolareToCheck = {
          codiceFiscale: this.form.codiceFiscaleTitolare,
          codiceRU: this.form.codiceRu,
          codiceBU: this.form.codiceBu
        }

        const titolareChecked = await this.$store.dispatch('abilitazioni/checkTitolareIncaricato', {
          titolare: titolareToCheck
        })

        if (!titolareChecked.verificato) {
          this.$ui.notify({
            type: 'warning',
            message: 'I dati del titolare non sono corretti. Verificare e riprovare.'
          })
          return
        }

        await this.$store.dispatch('caf/addDelega', this.form)
        this.$refs.modal.hide()
        this.$emit('delega-creata')
        this.$ui.notify({
          type: 'success',
          message: 'Delega creata con successo'
        })

      } catch (err) {
        this.$ui.showError(err)
      }
    },

    resetForm() {
      this.form = {
        codiceFiscaleTitolare: '',
        codiceRu: '',
        codiceBu: '',
        anniDichiarazione: '2019,2021,2023', 
        codiceFiscaleDichiarante: '',
        nominativoDichiarante: '',
        idSede: null
      }
    },

    show() {
      this.$refs.modal.show()
    }
  }
}
</script>